// import { unflatten } from 'flat';
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  InputGroup, Input, InputGroupAddon, InputGroupText,
  UncontrolledButtonDropdown,
  DropdownToggle, DropdownMenu, DropdownItem,
  Row, Col, FormGroup,
} from 'reactstrap';
import _ from 'lodash';
import { axios } from 'ApiClient';
import CheckboxFilter from '../../../../../shared/components/CheckboxFilter';
import {
  updateFilter,
} from '../../../../../redux/reducers/brand/ProspectsReducer';
import { countriesBH } from '../../../../../shared/helpers/WVConstants';
import Select from "react-select";

const Actions = React.memo(({
  dispatch,
  filters,
  brandFilters,
  setBrandFilters,
  // creatorTypeFilters,
  // setCreatorType,
  onSearchChange,
  setShowBulkEditModal,
  setShowRefreshModal,
  contentTypesFilters,
  setContentTypesFilters,
  searchQuery,
  searchValue,
}) => {
  const [search, setSearch] = useState(searchValue);
  const [dateSearch, setDateSearch] = useState(null);
  const [loadingProgramCountryOptions, setLoadingProgramCountryOptions] = useState(false);
  const [programCountryOptions, setProgramCountryOptions] = useState([]);

  const loadHubilCountriesOptions = async () => {
    setLoadingProgramCountryOptions(true);
    await axios.getSafety('/api/brand/dashboard/get-program-country-options').then((data) => {
      if (data.success === true && data.options?.length > 0) {
        const co = data.options.map(option => ({ value: option.value, label: option.label }));
        co.unshift({ value: null, label: '-- Not Assigned --' });
        setProgramCountryOptions(co);
      } else {
        setProgramCountryOptions([{ value: null, label: '-- Not Assigned --' }]);
        console.log('Program Country options are not available for this moment');
      }
    }).catch((err) => {
      console.log(err);
    });
    setLoadingProgramCountryOptions(false);
  };

  useEffect(() => {
    loadHubilCountriesOptions();
  }, []);

  const countryOpt = Object.entries(countriesBH()).map(entry => ({ value: entry[0], label: entry[1] }));
  countryOpt.unshift({ value: 'null', label: '-- Not Assigned --' });
  const selectedCountries = filters?.country?.map(f => f.value) || [];
  const selectedProgramCountries = filters?.programCountry?.map(f => f.value) || [];

  useEffect(() => {
    if (dateSearch) {
      clearTimeout(dateSearch);
    }
    setDateSearch(setTimeout(() => {
      onSearchChange(search);
    }, 1000));
  }, [search]);

  const colourStyles = {
    multiValue: styles => ({
      ...styles,
      backgroundColor: '#70bbfd',
    }),
    multiValueLabel: styles => ({
      ...styles,
      color: 'white',
    }),
    multiValueRemove: styles => ({
      ...styles,
      color: 'white',
      ':hover': {
        backgroundColor: '#a2e1fd',
        color: '#70bbfd',
      },
    }),
  };

  return (
    <div>
      <Row>
        <Col md={6}>
          <div className="float-left my-1" style={{ width: '3px' }} />
          <CheckboxFilter
            filterProp={brandFilters}
            filterTitle="&nbsp;&nbsp;Brand Status"
            filterAction={({ data }) => setBrandFilters(data)}
          />
          {/*<CheckboxFilter*/}
          {/*  filterProp={creatorTypeFilters}*/}
          {/*  filterTitle="Prospect Type"*/}
          {/*  filterAction={({ data }) => setCreatorType(data)}*/}
          {/*/>*/}
          <CheckboxFilter
            filterProp={contentTypesFilters}
            filterTitle="Content Type"
            filterAction={({ data }) => setContentTypesFilters(data)}
          />
        </Col>
        <Col>
          <UncontrolledButtonDropdown className="mt-2 float-right">
            <DropdownToggle caret className="mr-2" color="primary">
              Actions
            </DropdownToggle>
            <DropdownMenu>
              <DropdownItem onClick={() => setShowBulkEditModal(true)}>Update Status</DropdownItem>
              <DropdownItem onClick={() => setShowRefreshModal(true)}>Refresh Statistics</DropdownItem>
              <DropdownItem onClick={() => window.open(`/resources/prospects/download-csv?${searchQuery}`, '_blank').focus()}>Download CSV</DropdownItem>

            </DropdownMenu>
          </UncontrolledButtonDropdown>
        </Col>
      </Row>
      <Row>
        <Col md={4}>
          <InputGroup>
            <Input
              className="form-control-sm form-control ml-3"
              name="search"
              type="search"
              autoComplete="off"
              placeholder="Search First Name, Last Name, Email, YouTube Channel"
              value={search}
              onChange={p => setSearch(p.target.value)}
            />
            <InputGroupAddon addonType="append">
              <InputGroupText>
                <i
                  className="fa fa-search"
                  aria-hidden="true"
                  style={{ color: '#70bbfd', fontSize: 12 }}
                />
              </InputGroupText>
            </InputGroupAddon>
          </InputGroup>
        </Col>
        <Col md={4}>
          <FormGroup>
            <Select
              isMulti
              name="programCountrySelect"
              // isDisabled={loadingCreators}
              // isLoading={loadingCreators}
              isClearable
              value={programCountryOptions.filter(opt => selectedProgramCountries.includes(opt.value))}
              options={programCountryOptions}
              isDisabled={loadingProgramCountryOptions}
              isLoading={loadingProgramCountryOptions}
              onChange={(data) => { dispatch(updateFilter('programCountry', data)); }}
              placeholder="Program Countries"
              style={{ maxHeight: '120px', height: '31px' }}
              styles={colourStyles}
              theme={theme => ({
                ...theme,
                borderRadius: 0,
                spacing: {
                  ...theme.spacing,
                  controlHeight: 30,
                  baseUnit: 2,
                }
              })}
            />
          </FormGroup>
        </Col>
        <Col md={4}>
          <FormGroup>
            <Select
              isMulti
              name="countrySelect"
              // isDisabled={loadingCreators}
              // isLoading={loadingCreators}
              isClearable
              value={countryOpt.filter(opt => selectedCountries.includes(opt.value))}
              options={countryOpt}
              onChange={(data) => { dispatch(updateFilter('country', data)); }}
              placeholder="Countries"
              style={{ maxHeight: '120px', height: '31px' }}
              styles={colourStyles}
              theme={theme => ({
                ...theme,
                borderRadius: 0,
                spacing: {
                  ...theme.spacing,
                  controlHeight: 30,
                  baseUnit: 2,
                }
              })}
            />
          </FormGroup>
        </Col>
      </Row>
    </div>
  );
}, (a, a1) =>
  a.searchValue === a1.searchValue &&
  a.searchQuery === a1.searchQuery &&
  _.isEqual(a.filters, a1.filters) &&
  _.isEqual(a.contentTypesFilters, a1.contentTypesFilters) &&
  _.isEqual(a.brandFilters, a1.brandFilters));

Actions.propTypes = {
  dispatch: PropTypes.func.isRequired,
  filters: PropTypes.objectOf(PropTypes.any).isRequired,
  brandFilters: PropTypes.objectOf(PropTypes.any).isRequired,
  setBrandFilters: PropTypes.func.isRequired,
  // creatorTypeFilters: PropTypes.objectOf(PropTypes.any).isRequired,
  // setCreatorType: PropTypes.func.isRequired,
  onSearchChange: PropTypes.func.isRequired,
  setShowBulkEditModal: PropTypes.func.isRequired,
  setShowRefreshModal: PropTypes.func.isRequired,
  contentTypesFilters: PropTypes.objectOf(PropTypes.any).isRequired,
  setContentTypesFilters: PropTypes.func.isRequired,
  searchValue: PropTypes.string.isRequired,
  searchQuery: PropTypes.string.isRequired,
};
export default connect(state => ({
  filters: state.prospects.filters,
}))(Actions);
